export const copyText = (text, addToast) => {
  navigator.clipboard.writeText(text)
    .then(() => addToast('Os dados foram copiados.', 'success'),
      () => addToast('Houve um problema ao copiar os dados.'))
}
